import React from 'react'
import { Input, Label } from 'semantic-ui-react'

import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import dotProp from 'dot-prop'

class SemanticNumberWidget extends React.Component {
  render() {
    const { numberValue, options, entityModel, icon } = this.props

    // lang='en-150' for both komma's and dots as currency. https://www.ctrl.blog/entry/html5-input-number-localization
    return (
      <Input icon={icon} value={numberValue} type='number' min='0.0' step='1.00' lang='en-150' onWheel={(e) => e.target.blur()}
             onChange={ (event, props) => { this.props.dispatch(actions.change(entityModel, props.value))}}/>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  var entityModel = `${ownProps.model || ''}.${ownProps.id}`
  var numberValue = dotProp.get(state,entityModel)
  return {
    numberValue: numberValue,
    entityModel: entityModel
  }
}

export default connect(mapStateToProps)(SemanticNumberWidget);
